module.exports = __webpack_public_path__ + "assets/images/project/head/Joey_Alexander.jpg?v=2f138e32";